import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseResponseModel, PenggunaAplikasiModel, PenggunaAplikasiWithMenuModel, PenggunaInfoModel, PenggunaMenuModel, PenggunaOpdDtReqModel, PenggunaSekolahDtReqModel, SaldoKasModel } from '../_model/pengguna-info.model';
import { DatatablesModelResponse } from '../_model/utils/datatables.model';
import { MasterPeriodeDatatablesResModel, RequestNilaiNpd } from '../_model/bop-negeri/bop-list-bku';

@Injectable({ providedIn: 'root' })
export class PenggunaInfoService {

  constructor(
    private _http: HttpClient
  ) {
  }

  public findInfo() {
    return this._http.get<PenggunaInfoModel>(`${environment.uriAuth}/api/pengguna/find-info`, { observe: 'response' });
  }
  public findInfoByNrk(nrk: String) {
    return this._http.get<PenggunaInfoModel>(`${environment.uriAuth}/api/pengguna/find-by-nrk/${nrk}`, { observe: 'response' });
  }

  public listOtoritas() {
    return this._http.get<Array<string>>(`${environment.uriAuth}/api/pengguna/list-otoritas`, { observe: 'response' });
  }

  public listSekolah() {
    return this._http.get<Array<string>>(`${environment.uriAuth}/api/pengguna/list-sekolah`, { observe: 'response' });
  }

  public getSekolahById(id: number, tahunAnggaran: any) {
    return this._http.get<BaseResponseModel>(`${environment.uriApiBop}/api/sekolah/${id}/${tahunAnggaran}`, { observe: 'response' });
  }
  public getSekolahBosById(id: number, tahunAnggaran: any) {
    return this._http.get<BaseResponseModel>(`${environment.uriApi}/api/sekolah-bos/${id}/${tahunAnggaran}`, { observe: 'response' });
  }

  public getIdPelangganBySekolah(id: number, tahunAnggaran: any) {
    return this._http.get<BaseResponseModel>(`${environment.uriApiBop}/api/sekolah/idPelanggan/${id}/${tahunAnggaran}`, { observe: 'response' });
  }

  public getIdPelangganBySekolahBos(id: number, tahunAnggaran: any) {
    return this._http.get<BaseResponseModel>(`${environment.uriApiBop}/api/sekolah-bos/idPelanggan/${id}/${tahunAnggaran}`, { observe: 'response' });
  }
  public getVaPlnBySekolah(namaSekolah: any) {
    return this._http.post<BaseResponseModel>(`${environment.uriApiBop}/api/sekolah/getVaPln`, { namaSekolah: namaSekolah }, { observe: 'response' });
  }

  public listAplikasi() {
    return this._http.get<Array<PenggunaAplikasiModel>>(`${environment.uriAuth}/api/pengguna/list-aplikasi`, { observe: 'response' });
  }

  public listAplikasiWithMenu() {
    return this._http.get<Array<PenggunaAplikasiWithMenuModel>>(`${environment.uriAuth}/api/pengguna/list-aplikasi-with-menu`, { observe: 'response' });
  }

  public listMenuByIdAplikasi() {
    return this._http.get<Array<PenggunaMenuModel>>(`${environment.uriAuth}/api/pengguna/list-menu-by-id-aplikasi`, { observe: 'response' });
  }

  public datatablesOpd(parameters: any, value: PenggunaOpdDtReqModel) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    let params = new HttpParams();
    params = params.append('start', parameters.start);
    params = params.append('length', parameters.length);
    params = params.append('draw', parameters.draw);
    params = params.append('order[0][column]', parameters.order[0]['column']);
    params = params.append('order[0][dir]', parameters.order[0]['dir']);
    return this._http.post<DatatablesModelResponse>(`${environment.uriAuth}/api/pengguna/datatables/opd/${tahunAnggaran}`, value, { params: params });
  }

  public datatablesSekolah(parameters: any, value: PenggunaSekolahDtReqModel, sumberDana: string) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    let params = new HttpParams();
    params = params.append('start', parameters.start);
    params = params.append('length', parameters.length);
    params = params.append('draw', parameters.draw);
    params = params.append('order[0][column]', parameters.order[0]['column']);
    params = params.append('order[0][dir]', parameters.order[0]['dir']);
    return this._http.post<DatatablesModelResponse>(`${environment.uriAuth}/api/pengguna/datatables/sekolah/${tahunAnggaran}/${sumberDana}`, value, { params: params });
  }
  public saldoKas(id: number, tahunAnggaran: string) {
    return this._http.get<String>(`${environment.uriApi}/api/input-spj/saldo-kas/${id}/${tahunAnggaran}`, { observe: 'response' });
  }
  public saldoKasBop(id: number) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    return this._http.get<String>(`${environment.uriApiBop}/api-bop/input-spj-bop/saldo-kas/${id}/${tahunAnggaran}`, { observe: 'response' });
  }
  public saldoNpd(req: RequestNilaiNpd) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    return this._http.post<number>(`${environment.uriApiBop}/api-bop/input-spj-bop/saldo-npd`, req, { observe: 'response' });
  }
  public saldoNpdTerpakai(req: RequestNilaiNpd) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    return this._http.post<number>(`${environment.uriApiBop}/api-bop/input-spj-bop/saldo-npd-terpakai`, req, { observe: 'response' });
  }
  public getListDropping() {
    const tahunAnggaran = JSON.parse(localStorage.getItem('tahunAnggaran')!);
    return this._http.post<number>(
      `${environment.uriApi}/api/konfirmasi-dropping-dana/dropping-alert`,
      tahunAnggaran,
      { observe: 'response', headers: { 'Content-Type': 'text/plain' } }
    );
  }


  public getListDroppingBOP(nrk: string, periodeJenis: string, periode: string) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    return this._http.post<number>(`${environment.uriApiBop}/api/dropping-dana-bop/dropping-alert`, { tahunAnggaran: tahunAnggaran, nrk: nrk, periodeJenis: periodeJenis, periode: periode }, {
      observe: 'response'
    });
  }

  public findBySumberDana(sumberDana: number) {
    const tahunAnggaran = localStorage.getItem('tahunAnggaran');
    return this._http.get<MasterPeriodeDatatablesResModel>(`${environment.uriAuth}/api/master/periode/find-by-id/periode/${tahunAnggaran}/${sumberDana}`, { observe: 'response' });

  }
}
